"use strict";
exports.__esModule = true;
var basic_chart_component_1 = require("../basic-component/basic-chart.component");
var MAX_CHART_HEIGHT = 100000;
function findYOnLine(points, x3) {
    // Sort the points by their x-coordinate
    points.sort(function (a, b) { return a[0] - b[0]; });
    // Find the two points nearest to x3
    var x1, y1, x2, y2;
    for (var i = 0; i < points.length - 1; i++) {
        if (points[i][0] <= x3 && points[i + 1][0] >= x3) {
            x1 = points[i][0];
            y1 = points[i][1];
            x2 = points[i + 1][0];
            y2 = points[i + 1][1];
            console.log("Found points: (" + x1 + "," + y1 + ") and (" + x2 + "," + y2 + ")");
            break;
        }
    }
    // Calculate the slope of the line
    var m = (y2 - y1) / (x2 - x1);
    // Calculate the y-intercept
    var b = y1 - m * x1;
    // Calculate the y-coordinate at x3
    var y3 = m * x3 + b;
    var percentY3 = y3 * 100;
    return percentY3;
}
exports.findYOnLine = findYOnLine;
function assignXValue(mainSeriesData, siblingSeriesData) {
    var totalBars = mainSeriesData.length;
    mainSeriesData.forEach(function (row, index) {
        row.x = index;
        row.scatterX = index;
    });
    if (siblingSeriesData && siblingSeriesData.length > 0) {
        var positionFix_1 = 0.2;
        mainSeriesData.forEach(function (row, index) {
            row.scatterX -= positionFix_1;
            for (var _i = 0, siblingSeriesData_1 = siblingSeriesData; _i < siblingSeriesData_1.length; _i++) {
                var sibRow = siblingSeriesData_1[_i];
                if (!sibRow.x && sibRow.name === row.name) {
                    sibRow.x = index;
                    sibRow.scatterX = index + positionFix_1;
                    break;
                }
            }
        });
        siblingSeriesData.filter(function (row) { return !row.x; }).forEach(function (row) {
            row.x = totalBars;
            row.scatterX = totalBars + positionFix_1;
            totalBars += 1;
        });
    }
    return totalBars;
}
function getChartHeight(numOfBars) {
    var base = 60;
    return Math.min(MAX_CHART_HEIGHT, numOfBars * base + 300);
}
function generateSeries(dataRows, seriesName, zIndex) {
    if (zIndex === void 0) { zIndex = 6; }
    var series = [];
    var seriesData = dataRows.filter(function (item) {
        return typeof item.mean !== 'undefined';
    }).map(function (item) {
        item.fillColor = basic_chart_component_1.lightenDarkenColor(item.color, 70);
        return item;
    });
    if (seriesData.length > 0) {
        series.push({
            name: seriesName,
            zIndex: zIndex,
            data: seriesData,
            showInLegend: false
        });
        var meanValueScatters = seriesData.map(function (row) { return ({
            x: row.scatterX,
            y: row.mean,
            name: row.name,
            color: row.color
        }); });
        series.push({
            type: 'scatter',
            name: 'Mean Value (' + seriesName + ')',
            zIndex: zIndex,
            data: meanValueScatters,
            showInLegend: false
        });
    }
    return series;
}
function generateSeriesForLegend(dataRows, legends, nodeName) {
    var series = [];
    var colorsInRows = new Set(dataRows.map(function (row) { return row.color; }));
    for (var _i = 0, legends_1 = legends; _i < legends_1.length; _i++) {
        var legend = legends_1[_i];
        var tagKey = legend['tag'];
        var name_1 = tagKey === nodeName ? tagKey : tagKey + '(' + nodeName + ')';
        var tagColor = legend['color'];
        if (colorsInRows.has(tagColor)) {
            series.push({
                type: 'scatter',
                name: name_1,
                color: tagColor,
                marker: {
                    symbol: 'square',
                    fillColor: basic_chart_component_1.lightenDarkenColor(tagColor, 70)
                }
            });
        }
    }
    if (series) {
        series.unshift({
            type: 'scatter',
            name: 'Mean Value (' + nodeName + ')',
            color: series.length === 1 ? series[0].color : '#000000'
        });
    }
    return series;
}
function getAnalysisChartOptions(graph, options) {
    var currentNode = options.currentNode, _a = options.legends, legends = _a.legends, siblingLegends = _a.siblingLegends, settings = options.settings, timestamp = options.timestamp, chartInverted = options.chartInverted;
    var nodeName = currentNode.name;
    var chartTitle = 'Contribution by Project on ' + nodeName;
    var mainSeriesData = graph.mainRows.sort(function (a, b) { return b.mean - a.mean; });
    var siblingSeriesData = (graph.siblingRows || []).sort(function (a, b) { return b.mean - a.mean; });
    var totalBars = assignXValue(mainSeriesData, siblingSeriesData);
    var chartHeight = getChartHeight(totalBars);
    var yTitle = graph.Title + ' (' + graph.Units + ')';
    var series = generateSeries(mainSeriesData, nodeName, 6);
    series = series.concat(generateSeriesForLegend(mainSeriesData, legends, nodeName));
    if (siblingSeriesData.length > 0) {
        var siblingNodeName = siblingLegends[0]['tag'];
        var siblingSeries = generateSeries(siblingSeriesData, siblingNodeName, 5);
        series = series.concat(siblingSeries).concat(generateSeriesForLegend(siblingSeriesData, siblingLegends, siblingNodeName));
    }
    return {
        chart: {
            type: 'boxplot',
            renderTo: 'boxPlotChartContainer',
            height: chartHeight,
            width: 650,
            zoomType: 'xy',
            marginRight: 50,
            inverted: chartInverted
        },
        credits: {
            text: timestamp,
            href: null
        },
        title: {
            text: chartTitle
        },
        xAxis: {
            type: 'category',
            minRange: 1
        },
        yAxis: {
            // min: 0,
            title: {
                enabled: true,
                text: yTitle
            },
            labels: {
                enabled: true,
                formatter: function () {
                    return this.value;
                }
            },
            lineWidth: 0,
            crosshair: true,
            plotLines: [{
                    value: 0,
                    color: 'black',
                    width: 2,
                    zIndex: 1
                }]
        },
        legend: {
            enabled: true
        },
        tooltip: {
            enabled: settings.showTooltip,
            formatter: function () {
                if (this.point.mean) {
                    return "<b>" + this.point.name + "</b> <i>(" + this.series.name + ")</i><br />" +
                        ("<i> Value for " + yTitle + "</i><br />") +
                        ("10th Percentile: <b>" + this.point.low.toFixed(settings.decimals) + "</b>; <br />") +
                        ("25th Percentile: <b>" + this.point.q1.toFixed(settings.decimals) + "</b>; <br />") +
                        ("50th Percentile: <b>" + this.point.median.toFixed(settings.decimals) + "</b>; <br />") +
                        ("75th Percentile: <b>" + this.point.q3.toFixed(settings.decimals) + "</b>; <br />") +
                        ("90th Percentile: <b>" + this.point.high.toFixed(settings.decimals) + "</b>; <br />") +
                        ("Mean Value: <b>" + this.point.mean.toFixed(settings.decimals) + "</b>; <br />");
                }
                else {
                    return "<b>" + this.point.name + "</b> <i>(" + this.series.name + ")</i><br />" +
                        ("Mean " + yTitle + " Value: <b>" + this.point.y.toFixed(settings.decimals) + "</b>; <br />");
                }
            },
            crosshairs: [true, true]
        },
        plotOptions: {
            series: {
                groupPadding: 0.1
            },
            scatter: {
                pointPadding: 0.16,
                marker: {
                    radius: 4,
                    symbol: 'circle',
                    states: {
                        hover: {
                            enabled: true,
                            lineColor: 'rgb(100,100,100)'
                        }
                    }
                },
                states: {
                    hover: {
                        marker: {
                            enabled: false
                        }
                    }
                }
            }
        },
        series: series
    };
}
exports.getAnalysisChartOptions = getAnalysisChartOptions;
//# sourceMappingURL=goal-analysis.chart.js.map


// WEBPACK FOOTER //
// ./app/widgets/action/goal-analysis/goal-analysis.chart.js